export const isProd = process.env.NODE_ENV === "production";

export const API_URL = isProd
  ? "https://assets-crm.schoeffel.de/"
  : "http://localhost:3000/";

export const INSTANCE_URL = isProd
  ? "https://login.salesforce.com"
  : "https://test.salesforce.com";

export const PROXY_URL = "https://proxy-crm.schoeffel.de/proxy/";
export const IMAGE_URL = "https://images-crm.schoeffel.de/sch/";
export const IMAGE_SIZE_FOR_LIST = 200;
export const BIG_IMAGE_SIZE_FOR_DETAIL = 440;

export const MOBILE_BREAKPOINT = 770;

export const charCodes = {
  space: 32,
  enter: 13,
};

export const inputTypes = {
  number: "number",
};

export const priceTypes = {
  unit: "u",
  mrsp: "m",
};

export const debounces = {
  type: 300,
};

export const genres = {
  men: "Herren",
  woman: "Damen",
  Unisex: "Accessoires",
};

export const orderStatus = {
  unsynced: "unsynced",
  draft: "draft",
  done: "done",
  failedToSync: "failedToSync",
};

export const deliveryPeriodStatuses = {
  AVAILABLE: 0,
  CLOSED_BUT_ORDER_AVAILABLE: 1,
  NOT_AVAILABLE: 2,
};

export const OUTDOOR_CLUSTER = "Outdoor";
export const SKI_CLUSTER = "Ski";
export const BIKE_CLUSTER = "Bike";
